import React from 'react'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, branch, renderComponent, withState } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { fetchingState } from '../helpers/hocs.js'
import { getInfo, requestPaymentInfo, sendPayment } from '../store/reducers/payment'

import Overlay from './../components/Overlay'
import Error from './../components/Payment/Error'
import Form from './../components/Payment/Callback'
import Fallback from './../components/Payment/Fallback'
import NotFound from './404'

const PaymentPage = ({ fetching = {}, init, info, lot, fund, tab, request, requestPaymentInfo, contactModal, setModal, sendByCard, requestPayment }) => {
  if (fetching.initial && !init) return null
  if ((!fetching.initial && !init) || !info) return null

  const { currency, fields } = info

  if (tab === 'fail') {
    if (info.isPaid) return <NotFound />
    return <Error lot={lot} info={info} fields={fields} />
  }

  if (tab === 'success' || info.isPaid) {
    if (!info.isPaid) return <NotFound />
    return <Fallback lot={lot} fund={fund} info={info} />
  }

  if (request.message) {
    return (
      <div className='Fallback'>
        <div className='Container Container_light'>
          <div className='Fallback__body'>
            <h1 className='Signin__title Head'>{request.message}</h1>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='Pay'>
      <div className='Container Container_light'>
        <div className='Pay__body'>
          <div className='Pay__person'>
            <div className='Pay__person-img-wrap'>
              <img src={lot.image} alt={lot.title} className='Pay__person-img' />
              <div className='Pay__person-overlay' />
            </div>
            <div className='Pay__footer Text'>
              <h1 className='Pay__person-head Head'>
                {lot.title.split(' ').map((el, i) => <div key={i}>{el}</div>)}
              </h1>
              <div className='Pay__footer-meta Text'>
                <span className='Pay__footer-caption'>
                  {info.value ? numeral(info.value).format('0,0') : 0} {currency.symbol}
                  <br />
                  «{fund.name}»
                </span>
              </div>
            </div>
          </div>

          <button className='Button Button_white' type='submit' onClick={() => setModal(true)}>
            <FormattedMessage id='pay.do_payment' />
          </button>
          <br /><br />
          {/* <button className='Button Button_white' type='submit' onClick={requestPayment}>
            <FormattedMessage id='pay.pay' />
          </button> */}
          <div className='Pay__meta'>
            <span className='Label'>{info.status}</span>
          </div>
        </div>

        <Overlay isActive={contactModal} onClose={() => setModal(false)}>
          <Form
            currency={currency}
            init={requestPaymentInfo}
            value={info.value}
            fetching={fetching.send}
            onSubmit={sendByCard}
            onSuccess={() => setModal(false)}
            fromProfile={true}
          />
        </Overlay>
      </div>
    </div>
  )
}

// <Form fields={fields} url={info.url} />
// <a className='Pay__contact' href='#' onClick={e => requestPaymentInfo(e)}>Связаться со мной</a>
// {request.message && <div className='Text'>{request.message}</div>}

const mapStateToProps = ({ payment }) => ({ ...payment })
const mapDispatchToProps = dispatch => bindActionCreators({ getInfo, requestPaymentInfo, sendPayment }, dispatch)
const mergeProps = (state, { getInfo, sendPayment, requestPaymentInfo }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  getInfo: async id => {
    id = id || props.id
    if (!id) return
    const result = await fetchingWrap(getInfo.bind(this, id), 'initial')
    if (result !== 200) props.on404()
  },
  requestPaymentInfo: async e => {
    e && e.preventDefault()
    if (!state.lot || !state.lot._id) return
    return fetchingWrap(requestPaymentInfo.bind(this, state.lot._id), 'request')
  },
  requestPayment: async () => {
    if (!state.lot || !state.lot._id) return
    return fetchingWrap(sendPayment.bind(this, state.lot._id), 'send')
  },
  sendByCard: async data => {
    if (!state.lot || !state.lot._id) return
    const result = await fetchingWrap(sendPayment.bind(this, state.lot._id, data), 'send')
    if (result === 200) props.setModal(false)
  }
})

export default compose(
  branch(
    ({ id, tab }) => !id || (tab && [ 'fail', 'success' ].indexOf(tab) === -1),
    renderComponent(NotFound)
  ),
  fetchingState({ multi: true }),
  withState('contactModal', 'setModal', false),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    componentWillMount () {
      this.props.getInfo()
    },
    componentWillReceiveProps (np) {
      if (np.id && (np.id !== this.props.id)) this.props.getInfo(np.id)
      if (!np.id) this.props.on404()
    }
  })
)(PaymentPage)



// WEBPACK FOOTER //
// ./src/containers/Pay.jsx